var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finished",style:(_vm.styleText)},[_c('p',{staticClass:"finished-message"},[_vm._v(" "+_vm._s(_vm.finishtext)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }